import React, { Component } from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Button } from 'antd'
import Status from '../../../elements/Status'
import { dateFormat, filterCheckedColumns, moneyColumn } from '../../../modules/Utils'
import moment from 'moment'
import { MODAL_TYPE_EDIT } from '../../../elements/Hooks/useModalData'
import { CLAIM_MANAGER } from '../../../components/People/Claims/ClaimsCont'
import BoolFilter from '../../../elements/Select/BoolFilter'
import BoolCell from '../../../elements/Table/Cells/BoolCell'

class List extends Component {
  columns = [
    {
      Header: 'ID',
      accessor: '_key',
      Cell: ({ original, value }) => {
        return (
          <a onClick={e => this.props.onShowClaim(e, original, MODAL_TYPE_EDIT, original._key)}>
            {value}
          </a>
        )
      },
    },
    {
      Header: 'Name',
      accessor: 'claimant.fn',
      width: 500,
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: ({ value }) => value && dateFormat(moment(value)),
    },
    {
      Header: 'Category',
      accessor: 'category',
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      style: { textAlign: 'right' },
      Cell: ({ value }) => moneyColumn(value),
    },
    {
      Header: 'Currency',
      accessor: 'currency',
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ original, value }) => <Status tooltip={false} value={value} />,
      zIndex: 9999,
    },
    {
      Header: 'Processed',
      accessor: 'processed',
      filterMethod: filterCheckedColumns,
      Filter: BoolFilter,
      Cell: BoolCell,
      hideable: true,
      hideDefault: false,
    },
  ]

  render() {
    const { onShowClaim, list, fetch, fetching, option } = this.props
    if (option === 'personal') this.columns = this.columns.filter(c => c.accessor !== 'claimant.fn')

    return (
      <CustomTable
        isFilterable={true}
        CreateButton={() => (
          <Button
            type={'primary'}
            size={'small'}
            icon={'plus'}
            disabled={option === CLAIM_MANAGER}
            onClick={onShowClaim}>
            New{' '}
          </Button>
        )}
        fetch={fetch}
        fetching={fetching}
        columns={this.columns}
        data={list}
      />
    )
  }
}

List.propTypes = {}
List.defaultProps = {}

export default List
